import React from 'react';
import {SelectOption} from "./CommonUIElementTypes";

interface RadioOptionSetProps {
    onSelectRadioOption: Function;
    fieldName: string;
    options: SelectOption[];
    selectedOption?: SelectOption;
    wrapperClass?: string;
}

export let RadioOptionSet = function (props: RadioOptionSetProps) {
    function onSelectRadioOption(selectedOption: SelectOption) {
        props.onSelectRadioOption(props.fieldName, selectedOption);
    }

    let optionsDisplay = [];
    for (let i = 0; i < props.options.length; i++) {
        let option = props.options[i];

        optionsDisplay.push(
            <div key={i} className="common-radio-option" onClick={() => onSelectRadioOption(option)}>
                <div className={`common-radio-option-circle option-circle-${('' + option.value).replaceAll(' ', '-')}`}>
                    {(() => {
                        if (props.selectedOption && props.selectedOption.value === option.value) {
                            return (
                                <div className="common-radio-option-dot"/>
                            );
                        }
                    })()}
                </div>
                <div className="common-radio-option-label">{option.label}</div>
            </div>
        )
    }

    return (
        <div className={`radio-option-set ${props.wrapperClass || ''}`}>{optionsDisplay}</div>
    );
};
